// import { baseApi } from "./baseApi";

// interface CountryMeta {
//     current_page: number;
//     last_page: number;
//     total: number;
//     per_page: number;
// }

// interface CountriesResponse {
//     data: { id: string; name: string; flag: string }[];
//     meta: CountryMeta;
// }

// interface CountriesQueryArgs {
//     page?: number;
//     per_page?: number;
// }

// interface StateItem {
//     id: string;
//     name: string;
// }

// export const companyApi = baseApi.injectEndpoints({
//     endpoints: (builder) => ({
//         sendInvite: builder.mutation<any, { firstname?: string; last_name?: string; email?: string; is_hog: boolean }>({
//             query: (body) => ({ url: "/client/send-invite", method: "POST", body }),
//         }),

//         acceptInvite: builder.mutation<any, { id: string; password: string; password_confirmation: string }>({
//             query: ({ id, password, password_confirmation }) => ({
//                 url: `/accept-invite/${id}`,
//                 method: "POST",
//                 body: { password, password_confirmation },
//             }),
//         }),

//         rejectInvite: builder.mutation<any, { id: string; reason?: string }>({
//             query: ({ id, reason }) => ({ url: `/reject-invite/${id}`, method: "POST", body: { reason } }),
//         }),

//         acceptStaffInvite: builder.mutation<any, { id: string; password: string; password_confirmation: string }>({
//             query: ({ id, password, password_confirmation }) => ({
//                 url: `/accept-invite/${id}`,
//                 method: "POST",
//                 body: { password, password_confirmation },
//             }),
//         }),

//         rejectStaffInvite: builder.mutation<any, { id: string }>({
//             query: ({ id }) => ({ url: `/reject-invite/${id}`, method: "POST" }),
//         }),

//         profileSetup: builder.mutation<any, FormData>({
//             query: (formData) => ({ url: "/profile-setup", method: "POST", body: formData }),
//         }),

//         individualProfileSetup: builder.mutation<any, FormData>({
//             query: (formData) => ({ url: "/profile-setup", method: "POST", body: formData }),
//         }),

//         getAllServices: builder.query<{ id: string; name: string }[], void>({
//             query: () => "/services/all-services/type",
//             transformResponse: (response: any) => response.data,
//         }),

//         getCountries: builder.query<CountriesResponse, CountriesQueryArgs>({
//             query: ({ page = 1, per_page = 50 }) => ({
//                 url: `/country/getCountry`,
//                 method: "GET",
//                 params: { page, per_page },
//             }),
//             transformResponse: (response: any): CountriesResponse => ({
//                 data: response?.data?.data ?? [],
//                 meta: {
//                     current_page: response?.data?.current_page ?? 1,
//                     last_page: response?.data?.last_page ?? 1,
//                     total: response?.data?.total ?? 0,
//                     per_page: response?.data?.per_page ?? 50,
//                 },
//             }),

//             serializeQueryArgs: () => "company-countries-all",
//             merge: (currentCache, newItems, { arg }) => {
//                 if (arg.page === 1) {
//                     currentCache.data = newItems.data;
//                 } else {
//                     const existingIds = new Set(currentCache.data.map((c) => c.id));
//                     const fresh = newItems.data.filter((c) => !existingIds.has(c.id));
//                     currentCache.data.push(...fresh);
//                 }
//                 currentCache.meta = newItems.meta;
//             },
//             forceRefetch: ({ currentArg, previousArg }) => currentArg?.page !== previousArg?.page,
//         }),

//         getStates: builder.query<StateItem[], string>({
//             query: (countryId) => ({
//                 url: `/country/${countryId}/states`,
//                 method: "GET",
//             }),
//             transformResponse: (response: any): StateItem[] => response?.data ?? [],
//         }),

//         getHeadOrgInvite: builder.query<{ firstname: string; lastname: string; email: string }, string>({
//             query: (id) => ({ url: `/head-org/invitations/${id}`, method: "GET" }),
//             transformResponse: (response: any) => ({
//                 firstname: response.data.first_name,
//                 lastname: response.data.last_name,
//                 email: response.data.email,
//             }),
//         }),
//     }),
// });

// export const {
//     useSendInviteMutation,
//     useAcceptInviteMutation,
//     useRejectInviteMutation,
//     useGetCountriesQuery,
//     useGetStatesQuery,
//     useGetAllServicesQuery,
//     useProfileSetupMutation,
//     useIndividualProfileSetupMutation,
//     useAcceptStaffInviteMutation,
//     useRejectStaffInviteMutation,
//     useGetHeadOrgInviteQuery,
// } = companyApi;



import { baseApi } from "./baseApi";
import { setCompanyKyc } from "../slices/authSlice";

interface CountryMeta {
  current_page: number;
  last_page: number;
  total: number;
  per_page: number;
}

interface CountriesResponse {
  data: { id: string; name: string; flag: string }[];
  meta: CountryMeta;
}

interface CountriesQueryArgs {
  page?: number;
  per_page?: number;
}

interface StateItem {
  id: string;
  name: string;
}

export const companyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendInvite: builder.mutation<any, { firstname?: string; last_name?: string; email?: string; is_hog: boolean }>({
      query: (body) => ({ url: "/client/send-invite", method: "POST", body }),
      invalidatesTags: ["planLimit"],
    }),

    acceptInvite: builder.mutation<any, { id: string; password: string; password_confirmation: string }>({
      query: ({ id, password, password_confirmation }) => ({
        url: `/accept-invite/${id}`,
        method: "POST",
        body: { password, password_confirmation },
      }),
    }),

    rejectInvite: builder.mutation<any, { id: string; reason?: string }>({
      query: ({ id, reason }) => ({ url: `/reject-invite/${id}`, method: "POST", body: { reason } }),
    }),

    acceptStaffInvite: builder.mutation<any, { id: string; password: string; password_confirmation: string }>({
      query: ({ id, password, password_confirmation }) => ({
        url: `/accept-invite/${id}`,
        method: "POST",
        body: { password, password_confirmation },
      }),
    }),

    rejectStaffInvite: builder.mutation<any, { id: string }>({
      query: ({ id }) => ({ url: `/reject-invite/${id}`, method: "POST" }),
    }),

    profileSetup: builder.mutation<any, FormData>({
      query: (formData) => ({ url: "/profile-setup", method: "POST", body: formData }),
    }),

    individualProfileSetup: builder.mutation<any, FormData>({
      query: (formData) => ({ url: "/profile-setup", method: "POST", body: formData }),
    }),

    getAllServices: builder.query<{ id: string; name: string }[], void>({
      query: () => "/services/all-services/type",
      transformResponse: (response: any) => response.data,
    }),

    getCountries: builder.query<CountriesResponse, CountriesQueryArgs>({
      query: ({ page = 1, per_page = 50 }) => ({
        url: `/country/getCountry`,
        method: "GET",
        params: { page, per_page },
      }),
      transformResponse: (response: any): CountriesResponse => ({
        data: response?.data?.data ?? [],
        meta: {
          current_page: response?.data?.current_page ?? 1,
          last_page: response?.data?.last_page ?? 1,
          total: response?.data?.total ?? 0,
          per_page: response?.data?.per_page ?? 50,
        },
      }),

      serializeQueryArgs: () => "company-countries-all",
      merge: (currentCache, newItems, { arg }) => {
        if (arg.page === 1) {
          currentCache.data = newItems.data;
        } else {
          const existingIds = new Set(currentCache.data.map((c) => c.id));
          const fresh = newItems.data.filter((c) => !existingIds.has(c.id));
          currentCache.data.push(...fresh);
        }
        currentCache.meta = newItems.meta;
      },
      forceRefetch: ({ currentArg, previousArg }) => currentArg?.page !== previousArg?.page,
    }),

    getStates: builder.query<StateItem[], string>({
      query: (countryId) => ({
        url: `/country/${countryId}/states`,
        method: "GET",
      }),
      transformResponse: (response: any): StateItem[] => response?.data ?? [],
    }),

    getHeadOrgInvite: builder.query<{ firstname: string; lastname: string; email: string }, string>({
      query: (id) => ({ url: `/head-org/invitations/${id}`, method: "GET" }),
      transformResponse: (response: any) => ({
        firstname: response.data.first_name,
        lastname: response.data.last_name,
        email: response.data.email,
      }),
    }),

    // KYC status from the company record (companyInfo.kyc_verification / kyc_status).
    // Keeps the stored user in sync so the KYC popup reflects the backend's answer.
    getCompanyKycStatus: builder.query<{ kyc_verification: boolean; kyc_status: string | null } | null, void>({
      query: () => ({ url: "/company/get-company", method: "GET" }),
      transformResponse: (response: any) => {
        const info = response?.data?.companyInfo;
        if (!info || (info.kyc_verification === undefined && info.kyc_status === undefined)) return null;
        return { kyc_verification: info.kyc_verification === true, kyc_status: info.kyc_status ?? null };
      },
      providesTags: ["companyKyc"],
      async onQueryStarted(_arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          if (data) dispatch(setCompanyKyc(data));
        } catch {
          // Leave the stored value as it is if the check fails.
        }
      },
    }),

    submitKyc: builder.mutation<any, { companyId: string; data: FormData }>({
      query: ({ companyId, data }) => ({
        url: `/company/kyc/company/${companyId}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["companyKyc"],
    }),
  }),
});

export const {
  useSendInviteMutation,
  useAcceptInviteMutation,
  useRejectInviteMutation,
  useGetCountriesQuery,
  useGetStatesQuery,
  useGetAllServicesQuery,
  useProfileSetupMutation,
  useIndividualProfileSetupMutation,
  useAcceptStaffInviteMutation,
  useRejectStaffInviteMutation,
  useGetHeadOrgInviteQuery,
  useSubmitKycMutation,
  useGetCompanyKycStatusQuery,
  useLazyGetCompanyKycStatusQuery,
} = companyApi;